import { createSelector } from 'reselect';
import { RootState } from 'store/types';

/**
 * Lab Historical
 */
export const LabHistoricalSelector = (state: RootState) => state.testResults.labHistorical;

export const labHistoricalMillenniumLoadingSelector = createSelector(
  LabHistoricalSelector,
  labHistorical => labHistorical.millennium.isFetching
);

export const labHistoricalMillenniumErrorSelector = createSelector(
  LabHistoricalSelector,
  labHistorical => labHistorical.millennium.error
);

export const labHistoricalMillenniumDataSelector = createSelector(
  LabHistoricalSelector,
  labHistorical => labHistorical.millennium.data
);

export const labHistoricalCdrLoadingSelector = createSelector(
  LabHistoricalSelector,
  labHistorical => labHistorical.cdr.isFetching
);

export const labHistoricalCdrErrorSelector = createSelector(
  LabHistoricalSelector,
  labHistorical => labHistorical.cdr.error
);

export const labHistoricalCdrDataSelector = createSelector(
  LabHistoricalSelector,
  labHistorical => labHistorical.cdr.data
);

/**
 * Download Lab Results
 */
export const labDetailsDownloadsSelector = (state: RootState) =>
  state.testResults.downloadLabDetails;

export const labDetailsDownloadingSelector = createSelector(
  labDetailsDownloadsSelector,
  testResults => testResults.isDownloadingLabDetails
);

export const labDetailsDownloadDataSelector = createSelector(
  labDetailsDownloadsSelector,
  testResults => testResults.data
);

/**
 * Download Patient Letters
 */
export const patientLetterDownloadsSelector = (state: RootState) =>
  state.testResults.downloadPatientLetter;

export const patientLetterDownloadingSelector = createSelector(
  patientLetterDownloadsSelector,
  testResults => testResults.isDownloadingLetter
);

export const patientLetterDownloadDataSelector = createSelector(
  patientLetterDownloadsSelector,
  testResults => testResults.data
);

/**
 * Share Lab Results
 */
export const shareLabResultsSelector = (state: RootState) => state.testResults.shareLabResults;

export const shareLabResultsSendingSelector = createSelector(
  shareLabResultsSelector,
  shareLabResults => shareLabResults.isSendingLabResults
);

export const shareLabResultsDataSelector = createSelector(
  shareLabResultsSelector,
  shareLabResults => shareLabResults.sharedLabResultsData
);
